function rating(target) {

    var nbStars = parseInt($(target).attr('data-nb-stars'));
    var moyenne = parseInt($(target).attr('data-moyenne'));
    var hoverChange = $(target).attr('data-hover-change');
    var htmlStars = '';
    var active = '';
    var avis = ["Décevant", "Moyen", "Bien", "Très bien", "Excellent"];

    for (i = 1; i <= nbStars; i++) {

        if (i <= moyenne)
            active = 'active';
        else
            active = '';

        htmlStars += '<span class="star glyphicon glyphicon-star ' + active + ' star-' + i + '" data-avis="' + avis[i - 1] + '" data-note="' + i + '"></span>';
    }

    if (hoverChange === 'true') {
        
        htmlStars += '&nbsp; <span class="texte-courant-gras avis-utilisateur"></span>';

        $(target).html(htmlStars);
        
        var noteUtilisateur = $($(target).attr('data-note-utilisateur')).val();
        
        $(target + ' .star').on('mouseover click',function () {
            note = parseInt($(this).attr('data-note'));
            $(target + ' .star').removeClass('active');
            for (i = 1; i <= nbStars; i++) {
                if (i <= note) {
                    $(target + ' .star-' + i).addClass('active');
                    $('.avis-utilisateur').html($(target + ' .star-' + i).data('avis'));
                }
            }
        });
        
        $(target + ' .star').on('mouseout',function () {
            $(target + ' .star').removeClass('active');
            for (i = 1; i <= nbStars; i++) {
                if (i <= noteUtilisateur) {
                    $(target + ' .star-' + i).addClass('active');
                    $('.avis-utilisateur').html($(target + ' .star-' + i).data('avis'));
                }
            }
        });
        
        $(target + ' .star').on('click',function () {
            for (i = 1; i <= nbStars; i++) {
                if($(target + ' .star-' + i).hasClass('active')){
                    noteUtilisateur = parseInt($(target + ' .star-' + i).attr('data-note'));
                }
            }
            $($(target).attr('data-note-utilisateur')).val(noteUtilisateur);
        });
        
        
    } else {
        $(target).html(htmlStars);
    }

}

// Edition des réponses administrateur 

$('.edit-response').click(function () {
    var target = $(this).attr('data-target');
    $(target).find('textarea').removeAttr('readonly');
});
$('.save-response').click(function () {
    var target = $(this).attr('data-target');
    $(target).find('textarea').attr('readonly', 'readonly');
});